export default __webpack_public_path__ + "static/datelabel-dropdown-dont-3-dark-8c16565b478c32d1d8e482cdfb677d1af0cc0e407e1e0a5844a96316e05caad9.png";